import ReactGA from 'react-ga4';
const TRACKING_ID = "G-TRGVVMMCYT"; // your Measurement ID
const domain = window.location.hostname;

// Initialize GA once and disable default pageview tracking
ReactGA.initialize([{
    trackingId: TRACKING_ID,
    testMode: domain !== 'nohma.com',
    gaOptions: {
        // Prevents page view from being sent on initialization
        send_page_view: false,
    }
}], { 
    // Completely suppress automatic events (e.g., pageviews)
    gtagOptions: {
        send_page_view: false,
    }
});

export const trackGAEvent = (action) => {
    ReactGA.event({
        category: 'Pro form',
        action: action,
    });
};
